import { useState } from 'react';

import { Button, Popover, Tooltip } from 'antd';
import { PlusOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { useGetRelationGroupsByOfferQuery } from 'services';
import ArticleGroupModal from 'routes/article-group-management/article-group-modal';

import PopoverContent from './PopoverContent';

/**
 * Madde detay sayfasında grup bilgisini gösteren component.
 * Grup varsa: Tag (tıklayınca popover) + Edit butonu (modal açar)
 * Grup yoksa: "+" butonu (select modal açar)
 * @param {Object} props
 * @param {number} props.offerId - Madde teklifi numeric ID'si
 * @param {{ offerId: string, offerTitle: string, offerNumericId: number, offerStatus: number, offerStep: number }} props.autoAddArticle - Modal'a geçilecek otomatik ekleme bilgisi
 */
function ArticleGroup({ offerId, autoAddArticle }) {
  const { data } = useGetRelationGroupsByOfferQuery({ offerId });
  const [modalState, setModalState] = useState({ open: false, mode: 'select', initialData: null });
  const [popoverOpen, setPopoverOpen] = useState(false);

  const group = Array.isArray(data) && data.length > 0 ? data[0] : null;

  const handleClose = () => {
    setModalState({ open: false, mode: 'select', initialData: null });
  };

  const handleEdit = () => {
    setPopoverOpen(false);
    setModalState({ open: true, mode: 'edit', initialData: { id: group.id } });
  };

  return (
    <>
      {!group ? (
        <Tooltip title="Gruba Ekle">
          <Button
            type="text"
            shape="circle"
            onClick={() => setModalState({ open: true, mode: 'select', initialData: null })}
          >
            <PlusOutlined style={{ color: 'black' }} />
          </Button>
        </Tooltip>
      ) : (
        <Popover
          content={
            <PopoverContent
              groupId={group.id}
              onEdit={handleEdit}
            />
          }
          trigger="click"
          open={popoverOpen}
          onOpenChange={setPopoverOpen}
        >
          <Button
            icon={<UnorderedListOutlined />}
            type="text"
            shape="circle"
          />
        </Popover>
      )}
      <ArticleGroupModal
        mode={modalState.mode}
        open={modalState.open}
        onClose={handleClose}
        initialData={modalState.initialData}
        autoAddArticle={autoAddArticle}
      />
    </>
  );
}

export default ArticleGroup;
